import { useCallback, useRef } from "react";

/**
 * A callback that always closes over the latest data but keeps the same
 * identity and will not be called after component unmounts
 * @deprecated Try useEffectEvent, useCallback (or none ?) instead of this hook when possible
 */
export function useStableCallback<TFn extends ((...args: any[]) => any) | null | undefined>(
	cb: TFn,
): NonNullable<TFn> {
	// Create a mutable object that holds the callback
	const callbackRef = useRef<any>(cb);

	// Update the mutable object if the callback changes
	callbackRef.current = cb;

	// return a stable callback to prevent rerenders
	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	return useCallback<any>(
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
		(...args: any[]) => callbackRef.current && callbackRef.current(...args),
		[],
	);
}
